export default {
  ["Win Go"]: "Win Go",
  ["K3 Lotre"]: "K3 Lotre",
  ["大"]: "B",
  ["小"]: "S",
  ["单"]: "O",
  ["双"]: "E",
  ["奇"]: "O",
  ["偶"]: "E",
  ["2个匹配的数字: 赔率"]: "2 matching numbers: odds",
  ["一对不同的数字: 赔率"]: "A pair of unique numbers: odds",
  ["三个相同数字: 赔率"]: "3 of the same number: odds",
  ["任意三个相同数字：赔率"]: "Any 3 of the same number: odds",
  ["任意三个相同数字"]: "Any 3 of the same number",
  ["3个不同的数字:赔率 "]: "3 different numbers:odds ",
  ["3个连续数字:赔率 "]: "3 consecutive numbers:odds ",
  ["3个连续数字"]: "3 continuous numbers",
  ["2个不同的数字:赔率"]: "2 different numbers:odds",
  ["无效号码"]: "",
  ["二同号 (对子)"]: "",
  ["三同号 (豹子)"]: "",
  ["三连号 (顺子)"]: "",
  ["三不同号 (散号)"]: "",
  ["购彩详情"]: "betting details",
  ["Game history"]: "Game history",
  ["Chart"]: "Chart",
  ["My history"]: "My history",
  ["Period"]: "Period",
  ["Sum"]: "Sum",
  ["Results"]: "Results",
  ["Number"]: "Number",
  ["Total"]: "Total",
  ["Statistic (last 100 Periods)"]: "Statistic (last 100 Periods)",
  ["Missing"]: "Missing",
  ["Avg missing"]: "Avg missing",
  ["Frequency"]: "Frequency",
  ["Max consecutive"]: "Max consecutive",
  ["Stake"]: "Stake",
  ["Valid Stake"]: "Valid Stake",
  ["Big"]: "Big",
  ["Small"]: "Small",
  ["Odd"]: "Odd",
  ["Even"]: "Even",
  ["Balance"]: "Balance",
  ["Quantity"]: "Quantity",
  ["2个匹配数字"]: "2 matching numbers",
  ["一对不同的数字"]: "A pair of unique numbers",
  ["3个相同数字"]: "3 of the same number",
  ["任意3个相同的数字"]: "Any 3 of the same number",
  ["任意3个相同"]: "Any 3 of the same",
  ["3个不同的数字"]: "3 different numbers",
  ["3个连续的数字"]: "3 consecutive numbers",
  ["2个不同的数字"]: "2 different numbers",
  ["无效号码"]: "Invalid Number",
  ["二同号 (对子)"]: "Two of a Kind (Pair)",
  ["三同号 (豹子)"]: "Three of a Kind (Triple)",
  ["三连号 (顺子)"]: "Three in a Row (Straight)",
  ["三不同号 (散号)"]: "Three Different Numbers",
  ["Total amount Rp"]: "Total amount Rp",
  ["可用余额"]: "available balance",
  ["Cancel"]: "Cancel",
  ["Green"]: "Green",
  ["Violet"]: "Violet",
  ["Red"]: "Red",
  ["How to Play"]: "How to Play",
  ["Select"]: "Select",
  ["Big Small"]: "Big Small",
  ["Color"]: "Color",
  ["Statistic (last 100 Periods)"]: "Statistic (last 100 Periods)",
  ["Winning number"]: "Winning number",
  ["racing"]: "Racing",
  ["Random"]: "Random",
  ["All"]: "All",
  ["Clean"]: "Clean",
  ["P1~P5"]: "P1~P5",
  ["P6~P10"]: "P6~P10",
  ["Two-Sided Statistics"]: "Two-Sided Statistics",
  ["Basic Trend"]: "Basic Trend",
  ["Champion"]: "Champion",
  ["Runner-up"]: "Runner-up",
  ["Third place"]: "Third place",
  ["4th place"]: "4th place",
  ["5th place"]: "5th place",
  ["6th place"]: "6th place",
  ["7th place"]: "7th place",
  ["8th place"]: "8th place",
  ["9th place"]: "9th place",
  ["10th place"]: "10th place",
  ["First+Second sum"]: "First+Second sum",
  ["Champion Trend"]: "Champion Trend",
  ["Runner-up Trend"]: "Runner-up Trend",
  ["Third place Trend"]: "Third place Trend",
  ["P/L"]: "P/L",
  ["Awaiting Draw"]: "Awaiting Draw",
  ["No."]: "No.",
  ["Today"]: "Today",
  ["Yesterday"]: "Yesterday",
  ["This Week"]: "This Week",
  ["All States"]: "All States",
  ["Won"]: "Won",
  ["Lost"]: "Lost",
  ["All Types"]: "All Types",
  ["Type A"]: "Type A",
  ["Type B"]: "Type B",
  ["Max missing"]: "Max missing",
  ["First"]: "First",
  ["Second"]: "Second",
  ["Third"]: "Third",
  ["Fourth"]: "Fourth",
  ["Fifth"]: "Fifth",
  ["Sixth"]: "Sixth",
  ["Seventh"]: "Seventh",
  ["Eighth"]: "Eighth",
  ["Ninth"]: "Ninth",
  ["Tenth"]: "Tenth",
  ["Top"]: "Top",
  ["Last"]: "Last",
  ["SUM 1&2:"]: "SUM 1&2:",
  ["SUM 1&2"]: "SUM 1&2",
  ["big-odd"]: "big-odd",
  ["big-even"]: "big-even",
  ["Small-odd"]: "Small-odd",
  ["Small-even"]: "Small-even",
  ["Position"]: "Position",
  ["今天"]: "Today",
  ["昨天"]: "Yesterday",
  ["本周"]: "This Week",
  ["全部状态"]: "All States",
  ["待开奖"]: "Pending Draw",
  ["已开奖"]: "Drawn",
  ["已撤单"]: "Cancelled",
  ["全部开奖"]: "All Drawn",
  ["未中奖"]: "Not Won",
  ["已中奖"]: "Won",
  ["温馨提示"]: "Friendly Reminder",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: "",
  [""]: ""
};
